var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceleditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF594C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6597_9122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9694 21.5935L22.9695 21.5936C23.3483 21.9726 23.3483 22.5869 22.9694 22.9658C22.5905 23.3447 21.9762 23.3447 21.5973 22.9658L9.03809 10.4066C8.65925 10.0278 8.65918 9.41366 9.03786 9.03473C9.22711 8.84429 9.47623 8.74996 9.72381 8.74996C9.97231 8.74996 10.2206 8.84588 10.4099 9.03395L10.4104 9.0345L22.9694 21.5935Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03803 21.5936L9.0381 21.5935L21.5976 9.03505C21.5977 9.03494 21.5978 9.03483 21.5979 9.03472C21.7873 8.84438 22.0361 8.74996 22.2839 8.74996C22.5317 8.74996 22.7798 8.84603 22.9689 9.03395L22.9694 9.0345C23.3483 9.41341 23.3483 10.0277 22.9694 10.4066L10.4104 22.9658L10.4104 22.9659C10.0313 23.3447 9.41703 23.3448 9.03809 22.9658C8.65915 22.5869 8.65923 21.9726 9.03803 21.5936Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6597_9122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(1 0 0 -1 9 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceleditIcon);
export default __webpack_public_path__ + "static/media/canceledit_icon.4512131ae2b3229a42bde118397a28be.svg";
export { ForwardRef as ReactComponent };